import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import logo from './assets/icon.svg';

import React from "react";
import {Outlet} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Offcanvas from 'react-bootstrap/Offcanvas';
import LinkContainer from "react-router-bootstrap/LinkContainer";

import {useAuth} from "./contexts/AuthContext";

function RootLayout() {
    return (
        <Container fluid className="App d-flex flex-column min-vh-100">
            <Navigation />
            <Outlet />
            <Footer />
        </Container>
    );
}

const Navigation = () => {
    const { isAuthenticated } = useAuth()
    return (
        <Navbar fixed="top" expand="md" variant="dark" bg="dark" className="mb-3" collapseOnSelect={true}>
            <Container fluid>
                <LinkContainer to={"/"}>
                    <Navbar.Brand ><img src={logo} alt="Poker Ledger" width="30" height="30" /> Poker Ledger</Navbar.Brand>
                </LinkContainer>
                <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-md`} />
                <Navbar.Offcanvas
                    id={`offcanvasNavbar-expand-md`}
                    aria-labelledby={`offcanvasNavbarLabel-expand-md`}
                    placement="end"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id={`offcanvasNavbarLabel-expand-md`}>
                            Menu
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="justify-content-end flex-grow-1 pe-3">
                        {isAuthenticated ? (
                                <>
                                    <LinkContainer to="/games">
                                        <Nav.Link>Games</Nav.Link>
                                    </LinkContainer>
                                    <LinkContainer to={"/members"}>
                                        <Nav.Link>Members</Nav.Link>
                                    </LinkContainer>
                                    <LinkContainer to={"/logout"}>
                                        <Nav.Link>Log Out</Nav.Link>
                                    </LinkContainer>
                                    <LinkContainer to={"/feedback"}>
                                        <Nav.Link>Send Feedback</Nav.Link>
                                    </LinkContainer>
                                </>
                            ) : (
                                <>
                                    <LinkContainer to="/sign-up">
                                        <Nav.Link>Sign Up</Nav.Link>
                                    </LinkContainer>
                                    <LinkContainer to={"/login"}>
                                        <Nav.Link>Log In</Nav.Link>
                                    </LinkContainer>
                                </>
                            )
                        }
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container>
        </Navbar>
    );
}

const Footer = () =>
    <footer className="mt-auto bg-black text-center py-3">
        <div className="container px-5">
            <div className="mb-2">Copyright © {new Date().getFullYear()} <a href="https://www.rockygray.com">Gray Designs</a>. All Rights Reserved.</div>
        </div>
    </footer>

export default RootLayout;
